import React from 'react'
import { Box, Typography } from '@mui/material'
import Logo404 from 'assets/placeholders/404.png'

function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        background: '#f0f0f0'
      }}
    >
      <img src={Logo404} alt='Not Found' style={{ width: '300px' }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        <Typography>
          Oops
          <br /> Looks like you&apos;re lost...
        </Typography>
      </Box>

      <Typography variant='subtitle2'>
        The page you&apos;re looking for is not found.
      </Typography>
    </Box>
  )
}

export default NotFound
